export default function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_isString.js
// module id = 187
// module chunks = 1